// extracted by mini-css-extract-plugin
export var dividerContainer = "_8d-0";
export var line = "_8d-1";